import React from 'react';
import { useLotImage } from '../../utils/getLotImage';
import { useCommandeData } from './hooks/useCommandeData';
import { useCommandeTabs } from './hooks/useCommandeTabs';
import CommandeHeader from './components/CommandeHeader';
import CommandeTabs from './components/CommandeTabs';
import CommandeContent from './components/CommandeContent';
import './SuiviDeCommandeBCIV2.css';

// Skeleton plein ecran (chargement). Memes conteneurs/geometrie que le rendu reel -> aucun saut.
const CommandeBCISkeleton: React.FC = () => (
  <div className="scbc scbc-skeleton" aria-hidden="true">
    <div className="scbc-sk-banner">
      <div className="scbc-sk-back"><span className="scbc-sk scbc-sk-circle" /></div>
      <div className="scbc-sk-h1"><span className="scbc-sk" /></div>
      <div className="scbc-sk-h2"><span className="scbc-sk" /></div>
      <div className="scbc-sk-subtitle"><span className="scbc-sk" /></div>
      <div className="scbc-sk-statusline"><span className="scbc-sk" /></div>
    </div>
    <div className="scbc__content">
      <div className="scbc-sk-tabs">
        {Array.from({ length: 1 }).map((_, i) => (
          <span key={i} className="scbc-sk scbc-sk-tab" />
        ))}
      </div>
      <div className="scbc__tab-content">
        <div className="scbc-sk-content">
          <span className="scbc-sk scbc-sk-block" />
          <span className="scbc-sk scbc-sk-block" />
          <span className="scbc-sk scbc-sk-block scbc-sk-block--lg" />
        </div>
      </div>
    </div>
  </div>
);

// Page PRESTATAIRE commande-bci (V2, paniers importes). Orchestration mince : data -> onglet
// unique "Offre" -> rendu. Le presta consulte son offre et l'envoie a l'acheteur (par email).
const SuiviDeCommandeBCIV2: React.FC = () => {
  const { commande, loading, error, refetch } = useCommandeData();
  const lotImage = useLotImage(commande?.operation?.lot_technique?.nom);
  const { descriptors, activeIndex, activeTab, setActiveIndex } = useCommandeTabs(commande);

  if (loading) {
    return <CommandeBCISkeleton />;
  }

  if (error && !commande) {
    return (
      <div className="scbc__error">
        <p>Erreur: {error}</p>
        <p>Impossible de charger les détails de cette commande BCI.</p>
      </div>
    );
  }

  if (!commande) {
    return <div className="scbc__empty">Aucune commande BCI trouvée avec cet identifiant.</div>;
  }

  const numero = commande.operation?.numero ?? commande.id;
  const rang = commande.rang ?? 1;
  const lotTechnique = commande.operation?.lot_technique;
  const departement = commande.operation?.lot_departement?.departement;
  const subtitle =
    lotTechnique && departement
      ? `${lotTechnique.id} - ${lotTechnique.nom}, ${departement.id} - ${departement.nom}`
      : 'Informations de lot non disponibles';

  return (
    <div className="scbc">
      <div className="no-print">
        <CommandeHeader
          titre={commande.operation?.nom ?? 'Commande BCI'}
          sousTitre={''}
          subtitle={subtitle}
          commande={commande}
          backgroundImage={lotImage}
        />
      </div>

      <div className="scbc__content">
        <CommandeTabs descriptors={descriptors} activeIndex={activeIndex} onSelect={setActiveIndex} />
        <div className="scbc__tab-content">
          <CommandeContent commande={commande} activeTab={activeTab} refetch={refetch} />
        </div>
      </div>
    </div>
  );
};

export default SuiviDeCommandeBCIV2;
